import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { useMarketsContext } from './MarketContext';

import { Icon } from '../UI';
import { AssetInfoElement } from './AssetInfoElement';
import { useThemeContext } from '../../context/Theme';
import { IAsset } from '../../types/model';

const buttonClassName = `
  flex
  items-center
  border-grey-30
  border-l-1
  px-6
  py-2
  cursor-pointer
`;

export const MarketDetailBar = ({ asset }: { asset: IAsset }) => {
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { theme } = useThemeContext();

  const {
    assetsList,
    favoritesAssetsIds,
    addAssetToStrategy,
    handleAddAlert,
    handleStarClick,
  } = useMarketsContext();

  const isFavorite = favoritesAssetsIds.includes(id);

  return (
    <header
      className={`
          block
          w-full
          h-auto
          relative
          bg-white border border-grey-30 rounded-xl shadow-md dark:bg-grey-90 dark:border-grey-70
        `}
    >
      <div className="flex items-center content-center">
        <Icon
          svgName="arrowBack"
          className="ml-5 cursor-pointer h-4 w-4"
          onClick={() => navigate('/markets')}
        />
        <AssetInfoElement
          asset={asset}
          className="flex w-1/4 items-center ml-3 h-16"
          flexDirection="row"
          logoSize={8}
          showFavorite={false}
          useNav={false}
        />
        <div className="flex h-16 items-stretch ml-auto">
          {/* ADD TO STRATEGY */}
          <div
            className={buttonClassName}
            onClick={() =>
              addAssetToStrategy(id, asset.name, asset?.type ?? '')
            }
          >
            <Icon
              className="my-auto h-2.5 w-2.5"
              color="grey-50"
              svgName="plus"
            />
            <p
              className={`
                text-grey-50
                text-xs
                ml-1
                font-semibold
                capitalize-first
              `}
            >
              {t('common.add', { to: 'to strategy' })}
            </p>
          </div>

          {/* FAVORITE */}
          <div className={buttonClassName} onClick={() => handleStarClick(id)}>
            <Icon
              className={`w-4 h-4 mx-1 cursor-pointer cursor-pointer ${
                theme === 'DARK' && !isFavorite ? ' filter invert' : ''
              }`}
              fill={isFavorite}
              svgName="star"
            />

            <p
              className={
                'text-grey-50 dark:text-white text-xs ml-1 font-semibold'
              }
            >
              {isFavorite ? 'Remove favourites' : 'Add favourites'}
            </p>
          </div>

          {/* SMART ALERT */}
          <div
            className={buttonClassName}
            onClick={() => handleAddAlert(asset)}
          >
            <Icon svgName="bell" className="h-3 w-3" />
            <p className={'text-grey-50 text-xs ml-1 font-semibold'}>
              {t('markets.addSmartAlert')}
            </p>
          </div>
        </div>
      </div>
    </header>
  );
};
